<div class="map-container">
  <div id="leaflet-map" class="map"></div>
</div>

<div class="flex gap-3 justify-between my-1">
  <div class="city-map-card-footer">
    <div class="flex gap-3 items-end">
      <span class="city-map-card-footer-title">{{ occupiedSpotsPercent }}%</span>
      <span class="city-map-card-footer-subtitle"> Все районы </span>
    </div>
  </div>
</div>

<nz-progress
  class="city-map-card-footer-progress"
  [nzShowInfo]="false"
  [nzPercent]="occupiedSpotsPercent"
  [nzStrokeColor]="{
    '0%': '#49d638',
    '52%': '#ffce46',
    '100%': '#ff0000'
  }"
></nz-progress>
